<div class="not-found h-100 d-flex align-items-center">
  <div class="col">
    <h1 class="mb-3" i18n="@@page_notFound_title">Page not found</h1>
    <p class="text-light mb-5" i18n="@@page_notFound_description">
      You search a page that is not existing
    </p>
    <button
      [routerLink]="['/']"
      type="submit"
      class="btn btn-primary mt-5"
      i18n="@@page_notFound_backHomeLink"
    >
      Back home
    </button>
  </div>
</div>
